import { render, staticRenderFns } from "./FormularioValores.vue?vue&type=template&id=10578e9d&scoped=true&"
import script from "./FormularioValores.vue?vue&type=script&lang=ts&"
export * from "./FormularioValores.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioValores.vue?vue&type=style&index=0&id=10578e9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10578e9d",
  null
  
)

export default component.exports